// extracted by extract-css-chunks-webpack-plugin
module.exports = {"logo":"css-23lAWv9Y1G","logo_inner":"css-3stSzMbDi0"};